module.exports = __webpack_public_path__ + "images/OpenGraph.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/social/OpenGraph.png
// module id = 110
// module chunks = 0